import {
    IconNotes,
    IconStatusChange,
} from '@tabler/icons-react'
import { type SidebarData } from '../types'
import { BugIcon, CreditCardIcon, FileCheckIcon, FilesIcon, HomeIcon, LocationEditIcon, UserCogIcon } from 'lucide-react'

export const applicantProcessingSidebarData: SidebarData = {
    user: {
        name: '',
        email: '',
        avatar: '/avatars/shadcn.jpg',
    },

    navGroups: [
        {
            title: 'General',
            items: [
                {
                    title: 'Home',
                    url: '/',
                    icon: HomeIcon,
                },
                {
                    title: 'Check My Application',
                    url: '/application',
                    icon: LocationEditIcon,
                },
                {
                    title: 'Upload Documents',
                    url: '/application/documents',
                    icon: FilesIcon,
                },
                {
                    title: 'Payment Info',
                    url: '/payments',
                    icon: CreditCardIcon,
                },
                {
                    title: 'Change of Mind',
                    url: '/com',
                    icon: IconStatusChange,
                },
                {
                    title: 'Update My Details',
                    url: '/update-my-details',
                    icon: UserCogIcon,
                },
                {
                    title: 'POPIA',
                    url: '/popia',
                    icon: FileCheckIcon,
                }, {
                    title: 'Important Notices',
                    url: '/important-notices',
                    icon: IconNotes,
                },

                {
                    title: 'Report an Error',
                    icon: BugIcon,
                    url: '/report-error'
                },
            ],
        },



    ],
}
